import { __decorate } from "tslib";
import { LitElement, css, html, property, customElement, query } from 'lit-element';
let CdsDropdown = class CdsDropdown extends LitElement {
    constructor() {
        super(...arguments);
        this.hidden = false;
        this.position = 'bottom';
        this.anchor = '';
    }
    static get styles() {
        return [css `
      :host {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
      }

      :host([hidden]),
      :host([hidden]) dialog {
        display: none !important;
      }

      dialog {
        background: var(--cds-alias-object-overlay-background);
        z-index: 9999;
        border: 0;
        box-shadow: var(--cds-alias-object-shadow-100);
        padding: 12px;
        margin: 0;
        display: block;
      }

      dialog::backdrop {
        background: transparent;
        /* backdrop-filter: blur(2px); */
      }

      button {
        position: absolute;
        top: 0;
        right: 0;
        border: 0;
        background: transparent;
        cursor: pointer;
        font-size: 16px;
      }

      ::slotted(button) {
        display: block;
        border: 0;
        background: transparent;
        cursor: pointer;
        width: 100%;
        text-align: left;
        padding: 12px;
        box-shadow: 0;
      }

      ::slotted(button:hover) {
        background: hsl(0deg 0% 95%);
      }

      ::slotted(button[disabled]) {
        cursor: not-allowed;
        background: transparent;
      }
    `];
    }
    get _anchorRef() {
        return typeof this.anchor === 'string' ? this.getHost().querySelector(this.anchor) : this.anchor;
    }
    render() {
        return html `
      <dialog>
        <slot></slot>
      </dialog>
    `;
    }
    firstUpdated(props) {
        super.firstUpdated(props);
        this.addEventListener('click', event => {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientY < rect.top || event.clientY > rect.bottom ||
                event.clientX < rect.left || event.clientX > rect.right) {
                this.close();
            }
        });
        this.dialog.addEventListener('close', () => {
            if (!this.hidden) {
                this.close();
            }
        });
        this.addEventListener('keydown', (e) => {
            if (e.code === 'Enter' || e.code === 'Escape') {
                this.close();
            }
        });
    }
    updated(props) {
        super.updated(props);
        if (props.has('hidden') && props.get('hidden') !== undefined && props.get('hidden') !== this.hidden) {
            if (this.hidden) {
                this.dialog.close();
                this._anchorRef.focus();
            }
            else {
                this.open();
            }
        }
    }
    getHost() {
        var _a;
        const root = this.getRootNode();
        return ((_a = root === null || root === void 0 ? void 0 : root.host) === null || _a === void 0 ? void 0 : _a.shadowRoot) ? root.host.shadowRoot : root;
    }
    open() {
        const rect = this._anchorRef.getBoundingClientRect();
        this.dialog.style.left = `${rect.left}px`;
        this.dialog.showModal();
        this.dialog.style.top = this.position === 'top'
            ? `${rect.top - this.dialog.getBoundingClientRect().height}px`
            : `${rect.bottom + 1}px`;
    }
    close() {
        this.dispatchEvent(new CustomEvent('hiddenChange'));
    }
};
__decorate([
    property({ type: Boolean })
], CdsDropdown.prototype, "hidden", void 0);
__decorate([
    property({ type: String })
], CdsDropdown.prototype, "position", void 0);
__decorate([
    property({ type: String })
], CdsDropdown.prototype, "anchor", void 0);
__decorate([
    query('dialog', true)
], CdsDropdown.prototype, "dialog", void 0);
CdsDropdown = __decorate([
    customElement('cds-dropdown')
], CdsDropdown);
export { CdsDropdown };
//# sourceMappingURL=dropdown.element.js.map